import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center" style={ { backgroundColor: '#0b1a14' }}>
      <div className="text-center px-6">
        {/* 404 Number */}
        <div className="mb-8">
          <h1 className="text-9xl md:text-[12rem] font-bold text-[#C4A77D] mb-4" style={ { fontFamily: "'Playfair Display', serif" }}>
            404
          </h1>
          <div className="text-2xl md:text-3xl text-gray-400 mb-8" style={ { fontFamily: "'Playfair Display', serif" }}>
            Page Not Found
          </div>
        </div>

        {/* Error Message */}
        <div className="mb-12">
          <p className="text-gray-400 text-lg max-w-md mx-auto leading-relaxed">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        {/* Navigation Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-8 py-3 border border-[#C4A77D] text-[#C4A77D] text-xs uppercase tracking-wider transition-all duration-300 hover:bg-[#C4A77D] hover:text-black"
          >
            <ArrowLeft size={16} />
            Back to Home
          </Link>
          <Link
            to="/events"
            className="inline-flex items-center gap-2 px-8 py-3 border border-[#C4A77D] text-[#C4A77D] text-xs uppercase tracking-wider transition-all duration-300 hover:bg-[#C4A77D] hover:text-black"
          >
            Browse Events
          </Link>
        </div>

        {/* Contact Info */}
        <div className="mt-16 pt-8 border-t border-white/10">
          <p className="text-gray-500 text-sm">
            Need assistance? Contact our concierge team:
          </p>
          <a 
            href="mailto:info@raha-iduu.com" 
            className="text-[#C4A77D] hover:text-white transition-colors text-sm"
          >
            info@raha-iduu.com
          </a>
        </div>
      </div>
    </div>
  );
}
